export const NOTIFICATIONS_CONSTANTS = {
    ERROR: gettext('Oops! Something went wrong.'),
    SUCCESS: gettext('It\'s done!'),
};

export default NOTIFICATIONS_CONSTANTS;

export const TOAST_TYPE = {
    SUCCESS: 'success',
    ERROR: 'error',
};
